// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container-choose-route{padding:2rem}", "",{"version":3,"sources":["webpack://./resources/frontend/js/pages/chooseCustomRoutePage/chooseCustomRoute.scss"],"names":[],"mappings":"AAEA,wBACE,YADF","sourcesContent":["@import '../../../sass/variables';\n\n.container-choose-route {\n  padding: 2rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
